import React from 'react';
import { motion } from 'framer-motion';
import { Compass } from 'lucide-react';
export function InsideLook() {
  const discoveries = [{
    icon: '🏛',
    text: 'El nacimiento de una de las civilizaciones más importantes de la humanidad.'
  }, {
    icon: '⚡',
    text: 'Los secretos de los dioses del Olimpo y la mitología griega.'
  }, {
    icon: '⚔',
    text: 'Las hazañas de los héroes más legendarios.'
  }, {
    icon: '🐉',
    text: 'Monstruos y criaturas que inspiraron cientos de relatos.'
  }, {
    icon: '🔮',
    text: 'Misterios, profecías y leyendas que aún siguen sorprendiendo.'
  }, {
    icon: '🏺',
    text: 'El legado que Grecia dejó en la filosofía, la ciencia, el arte y la democracia.'
  }];
  return <section className="py-20 md:py-32 px-4 bg-dark-card/30 relative overflow-hidden" data-id="element-177">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-178" />

      <div className="max-w-4xl mx-auto" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-180">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-181">
            <Compass className="w-8 h-8 text-gold" data-id="element-182" />
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-8" data-id="element-183">
            ¿Qué vas a descubrir?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-184">
          {discoveries.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark border border-dark-border p-6 rounded-xl flex items-start gap-4 hover:border-gold/30 transition-colors" data-id="element-185">
              <span className="text-3xl" data-id="element-186">{item.icon}</span>
              <p className="text-gray-300 text-lg leading-relaxed" data-id="element-187">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}